// extracted by mini-css-extract-plugin
export default {"section":"styles_section__+LkDB","box":"styles_box__Xo3Of","box_left":"styles_box_left__ACwR7","box_right":"styles_box_right__JHrEs"};